import React from 'react';

import { FormControl } from 'components/v2/Form/FormControl/FormControl';
import { getFormControlIds } from 'components/v2/Form/FormControl/FormControl.utils';
import { TextInput } from 'components/v2/Inputs/TextInput/TextInput';

import { Props } from './TextField.types';

export const TextField = ({
  className,
  status = 'default',
  type = 'text',
  label,
  id,
  required,
  helperText,
  description,
  autoFocus,
  placeholder,
  spellCheck,
  autoComplete,
  value,
  onChange,
  onBlur,
  onKeyPress,
  onFocus,
  labelBg,
  rightIcon,
  onRightIconClick,
  postfix,
  hideDescription,
  hideHelperText,
  hideArrowsForNumberInput,
  max,
  step,
  fullWidth,
  maxLength
}: Props) => {
  const ids = getFormControlIds(id);

  return (
    <FormControl
      className={className}
      status={status}
      label={label}
      required={required}
      helperText={helperText}
      description={description}
      labelId={ids.label}
      inputId={ids.input}
      helperTextId={ids.helperText}
      labelBg={labelBg}
      hideDescription={hideDescription}
      hideHelperText={hideHelperText}
    >
      <TextInput
        type={type}
        id={ids.input}
        helperTextId={ids.helperText}
        labelId={ids.label}
        autoFocus={autoFocus}
        status={status}
        placeholder={placeholder}
        spellCheck={spellCheck}
        autoComplete={autoComplete}
        value={value ?? ''}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        onFocus={onFocus}
        rightIcon={rightIcon}
        onRightIconClick={onRightIconClick}
        postfix={postfix}
        hideArrowsForNumberInput={hideArrowsForNumberInput}
        max={max}
        step={step}
        fullWidth={fullWidth}
        maxLength={maxLength}
      />
    </FormControl>
  );
};
